import { rgba } from 'polished';
var WHITE = '#ffffff';
var FLOW_BLUE_300 = '#3283E6';
var GREEN_300 = '#128A00';
var GREY_700 = '#77818F';
var RED_300 = '#D2431F';
var YELLOW_300 = '#E6B137';
export var getColourStyle = function getColourStyle(intent) {
  switch (intent) {
    case 'info':
    case 'negative':
    case 'neutral':
    case 'positive':
    case 'warning':
      return WHITE;

    default:
      return undefined;
  }
};
export var getBackgroundStyle = function getBackgroundStyle(intent) {
  switch (intent) {
    case 'info':
      return rgba(FLOW_BLUE_300, 0.9);

    case 'neutral':
      return rgba(GREY_700, 0.9);

    case 'positive':
      return rgba(GREEN_300, 0.9);

    case 'warning':
      return rgba(YELLOW_300, 0.9);

    case 'negative':
      return rgba(RED_300, 0.9);

    default:
      return undefined;
  }
};